import { ConfirmationModal } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

interface ConfirmationModalType {
  isModalOpen: boolean;
  title?: string;
  subtitle?: string;
  action?: () => void;
  onClose?: () => void;
}

export const DeleteConfirmationModal = ({
  isModalOpen,
  title,
  subtitle,
  action,
  onClose,
}: ConfirmationModalType) => {
  const { language } = useLanguage();

  return (
    <ConfirmationModal
      subTitle={
        language === "bn"
          ? `আপনি কি " ${subtitle} " টি ডিলিট করতে চান ?`
          : `Do You want to delete " ${subtitle} " ?`
      }
      title={language === "bn" ? "ডিলিট অনুমোদন" : "Delete Confirmation"}
      isOpen={isModalOpen}
      onClose={onClose}
      closeAble
      overlay
      cancelButton={{
        label: language === "bn" ? "বাতিল করুন" : "Cancel",
        type: "light",
        fill: "outline",
        onClick: onClose,
      }}
      confirmButton={{
        label: language === "bn" ? "ডিলিট" : "Delete",
        type: "danger",
        onClick: action,
      }}
      portal
    />
  );
};
